__turbopack_context__.v({
  "relatedCard": "RelatedIndustriesSection-module__yJgCgW__relatedCard",
  "relatedCardInner": "RelatedIndustriesSection-module__yJgCgW__relatedCardInner",
  "relatedContainer": "RelatedIndustriesSection-module__yJgCgW__relatedContainer",
  "relatedGrid": "RelatedIndustriesSection-module__yJgCgW__relatedGrid",
  "relatedIcon": "RelatedIndustriesSection-module__yJgCgW__relatedIcon",
  "relatedSection": "RelatedIndustriesSection-module__yJgCgW__relatedSection",
  "relatedTitle": "RelatedIndustriesSection-module__yJgCgW__relatedTitle",
});
